<template>
  <v-footer v-if="aktif"
      color="indigo"
      app
      dark
      inset
  >
    <span class="white--text">&copy; 2020 - SARANA JAYA</span>
    <v-spacer></v-spacer>
    <span class="white--text">{{ divisi }} - {{ user }}</span>
    <span class="white--text mx-2" v-if="perusahaan !== ''"> - </span>
    <span class="white--text">{{ perusahaan }}</span>
  </v-footer>
</template>

<script>

import { getValueItem, itemsDivisi } from "./../../lib/viewLib"

export default {
  data: function() {
    return {
      itemsDivisi: itemsDivisi,
    }
  },
  computed: {
    aktif: function() {
      return this.$store.getters.isAuthenticated
    },
    user: function() {
      return this.$store.getters.userInfo.nama
    },
    divisi: function() {
      console.log('this.$store.getters.userInfo.divisi', this.$store.getters.userInfo.divisi)
      
      return this.getValueItem(this.itemsDivisi, this.$store.getters.userInfo.divisi)
    },
    perusahaan: function() {
      return this.$store.getters['ven/venName']
    }
  },
  methods: {
    getValueItem: getValueItem,

  }
}
</script>

<style>

</style>